import { Component, inject, ViewChild } from '@angular/core';
import { MainHeaderComponent } from '../../shared/main-header/main-header.component';
import { Table, TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MissionsService } from '../../../services/missions.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PrimeNGConfig } from 'primeng/api';
import { Observable, tap } from 'rxjs';
import { Task } from '../../../models/task';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataTableComponent } from '../../shared/data-table/data-table.component';
import { MatDialog } from '@angular/material/dialog';
import { EditorJsonComponent } from '../../shared/editor-json/editor-json.component';
import { UsersService } from '../../../users/users.service';


@Component({
  selector: 'app-list',
  standalone: true,
  imports: [CommonModule, MainHeaderComponent, TableModule, MatIconModule, MatButtonModule, MatMenuModule, RouterLink, MatFormFieldModule, DataTableComponent],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListComponent {
  tasks$!: Observable<Task[]>
  selected!: Task[];
  products!: Task[];
  selectedProducts: Task[] = [];
  canDelete: boolean = false;
  selectedItems: any[] = [];


  readonly dialog = inject(MatDialog);

  columns: any[] = [
    { field: 'task_id', header: 'Id', filter: true, orderby: true },
    { field: 'name', header: 'Nombre', filter: true, orderby: true },
    { field: 'task_key', header: 'Key', filter: true, orderby: true },
    { field: 'required_score', header: 'Requerido', filter: true, orderby: true }
  ];

  @ViewChild('dt') table!: Table;
  constructor(public missionsService: MissionsService, private _snackBar: MatSnackBar, private router: Router, private userService: UsersService) { }

  ngOnInit(): void {
    this.userService.loadUsersStore()
    this.checkUserRoles()
    this.missionsService.loadTaskStore()
    
  } 

  checkUserRoles(): void {
    this.userService.getCurrentUserUid$().subscribe((uid) => {
    if (uid) {
      this.userService.users$.subscribe((users) => {
        const currentUser = users.find((user) => user.uid === uid);
        if (currentUser) {
          this.canDelete = currentUser.roles?.admin || currentUser.roles?.superadmin || false;
          // console.log('Roles cargados:', currentUser.roles, 'Can Delete:', this.canDelete);
        } else {
          
          this.canDelete = false;
        }
      });
    } else {
      
      this.canDelete = false;
    }
  });
  }

  onSelectionChange(event: any) {
    console.log('event', event)
    this.selectedProducts = event;
  }
  onEditItem(item: any) {
    console.log('onEditItem items:', item);
    this.router.navigate(['/missions', item.task_id]);
  }
  onExport(item: any) {
    console.log('onEditItem items:', item);
    this.openDialog(item.task_id)

    // this.router.navigate(['/missions', item.task_id]);
  }
  onDeleteItems(items: any) {
     if (!this.canDelete) {
      this._snackBar.open('No tienes permisos para eliminar esta regla' , 'Cerrar', {duration: 3000});
      return;
    }
    if (window.confirm("Esto eliminará esta tarea y todas sus configuraciones")) {
        this.missionsService.deleteTask(items.task_id).subscribe( () => {
          this.selectedProducts = []
          console.log('task delete')
          this._snackBar.open(`Tarea ${items.task_id} eliminada.`, 'ok');
           this.missionsService.loadTaskStore()
        })
    } 
  }

  deleteTask(task: Task[]) {
     if (!this.canDelete) {
      this._snackBar.open('No tienes permisos para eliminar esta regla' , 'Cerrar', {duration: 3000});
      return;
    }
    if (window.confirm("Esto eliminará esta tarea y todas sus configuraciones")) {
      task.map(task => {
        this.missionsService.deleteTask(task.task_id).subscribe({ next : (response) => {
          this.selectedProducts = []
          console.log('task delete', task.task_id)
          this._snackBar.open(`Tarea ${task.task_id} eliminada.`, 'ok');
          this.missionsService.loadTaskStore()
        }
        })
      })
    }
  }

  onRowSelect(event: any) {
    //this.selectedProducts.push(event)
    console.log('onRowSelect _ _', this.selectedProducts)
  }

  handleFilter(event: Event) {
    console.log("evento", event)
    const inputElement = event.target as HTMLInputElement;
    this.table.filterGlobal(inputElement.value, 'contains');
  }

  openDialog(id:any): void {
    const dialogRef = this.dialog.open(EditorJsonComponent, {
      data: { task_id: id },
    });
    console.log('The dialog was open');
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result !== undefined) {
        // this.animal.set(result);
      }
    });
  } 

  onClone(item : any) {
    console.log("item", item)
    console.log("ID", item.task_id)
    this.missionsService.cloneTask(item.task_id).subscribe({
      next: (response) => {
        const confirmEdit = confirm(
          '¡Duplicación con éxito!! ¿Quiere ser direccionado al nuevo elemento?'
        )

        if (confirmEdit) {
          this.router.navigate(['missions', response.task_id]);
        } 
        else  {
          this._snackBar.open(`Tarea ${item.task_id} clonada exitosamente.`, 'ok', {duration: 3000})
          this.missionsService.loadTaskStore()
        }
      },
      error: (err) => {
       console.error('Error al clonar la tarea', err)
      }, 
    })
  }

}
